import { differenceInMinutes } from 'date-fns';
import { TRIAL_LESSON_PRICE } from '@shared/lib/trial';

const STORAGE_URL = process.env.REACT_APP_STORAGE_URL

export const getAvatarUrl = (avatar) => {
    if (!avatar) return null
    if (typeof avatar === 'string') return avatar
    return avatar?.image ? STORAGE_URL + avatar.image : null
}

export const mapStudentPack = (pack) => ({
    id: pack?.id,
    teacherImg: getAvatarUrl(pack?.teacher?.avatar),
    teacherName: pack?.teacher?.name,
    status: pack?.status,
    lessonsCount: pack?.lessons_count,
    lessonsUsed: pack?.lessons_used,
    price: pack?.price,
    dateExpire: pack?.expires_at,
    dateCreated: pack?.created_at,
    teacherPriceOneLesson: pack?.teacher?.grade?.price,
    teacherSlug: pack?.teacher?.teacher_slug,
    teacherId: pack?.teacher?.id,
    appointments: pack?.appointments ?? []
})

export const mapStudentLesson = (lesson) => ({
    id: lesson?.id,
    teacherImg: getAvatarUrl(lesson?.teacher?.avatar),
    teacherName: lesson?.teacher?.name,
    status: lesson?.status,
    subject: lesson?.instrument?.name,
    teacherSlug: lesson?.teacher?.teacher_slug,
    date: lesson?.starts_at,
    createdAt: lesson?.created_at,
    duration: lesson?.starts_at && lesson?.ends_at
        ? differenceInMinutes(lesson.ends_at, lesson.starts_at)
        : null,
    // Цена, которую реально оплатил ученик (с учётом скидки).
    // Фолбэк на прайс грейда — пока бэк не отдаёт оплаченную сумму.
    price: lesson?.is_trial ? TRIAL_LESSON_PRICE : (lesson?.price ?? lesson?.teacher?.grade?.price),
    // Бесплатное занятие (бронирование вне платёжного шлюза)
    isFree: !lesson?.is_trial && !!lesson?.outside_payment,
    isTrial: !!lesson?.is_trial,
})

export const mapTeacherPack = (pack) => ({
    id: pack?.id,
    teacherImg: getAvatarUrl(pack?.student?.avatar),
    teacherName: pack?.student?.name,
    subject: pack?.instrument?.name ?? pack?.student?.instrument?.name,
    level: pack?.student?.level,
    status: pack?.status,
    lessonsCount: pack?.lessons_count,
    lessonsUsed: pack?.lessons_used,
    price: pack?.price,
    dateExpire: pack?.expires_at,
    dateCreated: pack?.created_at,
    teacherPriceOneLesson: pack?.grade?.price ?? pack?.teacher?.grade?.price,
    studentId: pack?.student?.id,
    appointments: pack?.appointments ?? []
})

export const mapTeacherLesson = (lesson) => ({
    id: lesson?.id,
    teacherImg: getAvatarUrl(lesson?.student?.avatar),
    teacherName: lesson?.student?.name,
    status: lesson?.status,
    subject: lesson?.instrument?.name,
    experience: lesson?.student?.level,
    date: lesson?.starts_at,
    createdAt: lesson?.created_at,
    duration: lesson?.starts_at && lesson?.ends_at
        ? differenceInMinutes(lesson.ends_at, lesson.starts_at)
        : null,
    // Цена, которую реально оплатил ученик (с учётом скидки).
    // Фолбэк на прайс грейда — пока бэк не отдаёт оплаченную сумму.
    price: lesson?.is_trial ? TRIAL_LESSON_PRICE : (lesson?.price ?? (lesson?.teacher?.grade?.price ?? lesson?.grade?.price)),
    // Бесплатное занятие (бронирование вне платёжного шлюза)
    isFree: !lesson?.is_trial && !!lesson?.outside_payment,
    isTrial: !!lesson?.is_trial,
    receipt: lesson?.teacher_receipt?.receipt_file,
})
